import React, { useState, useEffect, useRef } from "react";
import { DYRUrl } from "../../Services/Api";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { CiWarning } from "react-icons/ci";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import BottomToust from "../../Components/BottomToust/BottomToust";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";

const AllProductsDYR = () => {
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const rowsPerPage = 10;

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchTableData(currentPage);
  }, [currentPage]);

  const fetchTableData = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetch(`${DYRUrl}/api/v1/products/get-all?page=${page}`);
      const result = await response.json();
      setData(result.data || []);
      setFilteredData(result.data || []);
      setPagination(result.pagination);
      setToastMessage("Products fetched successfully!");
      setShowMessage(true);
    } catch (error) {
      setToastMessage("Failed to fetch products.");
      setShowMessage(true);
    } finally {
      setLoading(false);
    }
  };

  const Columns = [
    {
      name: "Image",
      selector: row =>
        loading ? <ShimmerLoader width="100px" height="20px" /> : (
          <img src={DYRUrl + row?.png_image?.image_url} alt="Product" style={{ height: "50px", maxWidth: "100%" }} />
        ),
      minWidth: "100px",
      maxWidth: "150px",
    },
    {
      name: "Name",
      selector: row => loading ? <ShimmerLoader width="100px" height="20px" /> : row.name,
      grow: 2,
      wrap: true,
    },
    {
      name: "SKU",
      selector: row => loading ? <ShimmerLoader width="100px" height="20px" /> : row.sku,
      grow: 2,
      wrap: true,
    },
    {
      name: "Category",
      selector: row => loading ? <ShimmerLoader width="100px" height="20px" /> : row?.subCategoryId?.name,
      grow: 2,
      wrap: true,
    },
    {
      name: "Regular Price",
      selector: row => loading ? <ShimmerLoader width="100px" height="20px" /> : "$" + row.regular_price,
      grow: 1,
      wrap: true,
    },
    {
      name: "Sale Price",
      selector: row => loading ? <ShimmerLoader width="100px" height="20px" /> : "$" + row.sale_price,
      grow: 1,
      wrap: true,
    },
    {
      name: "Action",
      cell: row => loading ? <ShimmerLoader width="60px" height="20px" /> : (
        <div>
          <img
            src={actionIcon}
            alt="Actions"
            width="30"
            height="30"
            style={{ cursor: "pointer" }}
            onClick={() => toggleDropdown(row._id)}
          />
          {openDropdownId === row._id && (
            <div className="dropdown-menu show animate-dropdown-left">
              <ul>
                <li onClick={() => handleEdit(row)}><FiEdit /> Edit</li>
                <li onClick={() => confirmDelete(row)}><RiDeleteBin6Line /> Delete</li>
              </ul>
            </div>
          )}
        </div>
      ),
      minWidth: "100px",
      maxWidth: "130px",
    },
  ];

  const toggleDropdown = id => {
    setOpenDropdownId(prevId => (prevId === id ? null : id));
  };

  const handleEdit = row => {
    navigate(`/design-your-room/edit-product/${row._id}`, { state: { productData: row } });
  };

  const confirmDelete = row => {
    setCurrentRowId(row._id);
    setShowConfirm(true);
  };

  const handleDelete = () => {
    console.log(`Deleting item with ID: ${currentRowId}`);
    if (currentRowId) {
      deleteItem(currentRowId);
    }
  };

  const deleteItem = async (id) => {
    setIsLoading(true);
    try {
      let successMessage = "Order deleted successfully!";
      console.log(`Attempting to delete item with ID: ${id}`);

      const response = await fetch(`${DYRUrl}/api/v1/products/${id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      console.log(`Delete response: `, responseData);
      console.log(`Selection with ID ${id} deleted successfully.`);

      setData((prevItems) => prevItems.filter((item) => item._id !== id));

      setToastMessage(successMessage);
      setShowMessage(true);

      fetchTableData();
    } catch (error) {
      let errorMessage = "Failed to delete the selection. Please try again.";
      console.error("Error deleting item:", error);
      setToastMessage(errorMessage);
      setShowMessage(true);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        // setIsActive(false);
      }, 5000);
      setShowConfirm(false);
    }
  };

  const handleClickOutside = event => {
    if (!event.target.closest(".dropdown-menu") && !event.target.closest(".bar-icon")) {
      setOpenDropdownId(null);
    }
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShowConfirm(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="AllOrderPage">
      <div className="Orders-Table-Data">
        <DataTable
          columns={Columns}
          data={filteredData}
          customStyles={{
            cells: { style: { wordBreak: "break-word", whiteSpace: "normal" } },
          }}
        />
        <Pagination
          activePageIndex={currentPage}
          totalPages={pagination?.totalPages || 1}
          onPrevPage={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          onNextPage={() => setCurrentPage(prev => Math.min(prev + 1, pagination?.totalPages || 1))}
          onPageChange={setCurrentPage}
        />
      </div>

      {showConfirm && (
        <div className="confirmation-modal">
          <div className="Cat-modal-content" ref={modalRef}>
            <CiWarning className="warning-icon" />
            <div className="Delete-Heading">Warning</div>
            <div className="Delete-Content">
              Are you sure you want to delete this product? <br /> This action cannot be undone.
            </div>
            <div className="separator-line"></div>
            <div className="modal-actions">
              <button className="Cat-Delete-btn btn-secondary" onClick={() => setShowConfirm(false)}>Cancel</button>
              <div className="SubmitBtn">
                <CustomBtn
                  label={isLoading ? <div className="btn-loader-Category"></div> : "Confirm"}
                  className="Cat-Delete-btn btn-danger"
                  disabled={isLoading}
                  onClick={handleDelete}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => setShowMessage(false)}
      />
    </div>
  );
};

export default AllProductsDYR;
